import { Baby, Laptop2, Rocket, Sparkles } from "lucide-react";
import { motion } from "framer-motion";

const CareerTimeline = () => {
  const milestones = [
    {
      year: "Now",
      title: "Master's Degree",
      description: "AI and Big Data Student",
      icon: <Sparkles className="w-4 h-4" />,
    },
    {
      year: "2024",
      title: "Bachelor's Degree",
      description: "Junior Developer",
      icon: <Rocket className="w-4 h-4" />,
    },
    {
      year: "2023",
      title: "Diploma",
      description: "Full Stack Developer",
      icon: <Laptop2 className="w-4 h-4" />,
    },
    {
      year: "2021",
      title: "First Code",
      description: "Started learning HTML/CSS",
      icon: <Baby className="w-4 h-4" />,
    },
  ];

  const fadeIn = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.3 } },
  };

  return (
    <section className="py-20 bg-white dark:bg-black">
      <div className="container mx-auto px-4 max-w-4xl">
        {/* Section header */}
        <motion.div
          className="text-center mb-12"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeIn}
        >
          <h2 className="text-3xl text-gray-900 dark:text-white mb-3 flex items-center justify-center gap-2">
            <Rocket className="w-7 h-7 text-indigo-500 dark:text-indigo-400" />
            Career Journey
          </h2>
          <div className="w-40 h-px bg-gray-300 dark:bg-gray-700 mx-auto" />
          <p className="text-gray-600 dark:text-gray-400 max-w-5xl mt-2 mx-auto text-center text-base font-light mb-8">
            A timeline of my growth, technical milestones, and the experiences that have shaped my approach to solving complex problems.
          </p>
        </motion.div>

        {/* Timeline - horizontal scroll on mobile, centered on desktop */}
        <div className="relative">
          {/* Subtle connecting line (desktop) */}
          <div className="absolute left-0 right-0 top-6 h-px bg-gray-200 dark:bg-gray-800 hidden md:block" />

          <div className="flex overflow-x-auto pb-6 md:pb-0 md:flex-wrap md:justify-center gap-6 md:gap-8 scrollbar-hide">
            {milestones.map((milestone, index) => (
              <motion.div
                key={index}
                variants={fadeIn}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="flex-shrink-0 w-40 md:w-auto md:flex-1 text-center relative"
              >
                {/* Icon with circle */}
                <div className="relative z-10 inline-flex items-center justify-center w-12 h-12 rounded-full bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-indigo-500 dark:text-indigo-400">
                  {milestone.icon}
                </div>

                {/* Year */}
                <div className="mt-2 text-xs font-medium text-gray-400 dark:text-gray-500">
                  {milestone.year}
                </div>

                {/* Title */}
                <h3 className="text-sm font-medium text-gray-900 dark:text-white mt-1">
                  {milestone.title}
                </h3>

                {/* Description – hidden on small screens, visible on hover/desktop */}
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-1 hidden md:block">
                  {milestone.description}
                </p>

                {/* Optional tooltip-like appearance on mobile? Not needed. */}
              </motion.div>
            ))}
          </div>
        </div>

        {/* Optional: subtle note for mobile */}
        <p className="text-xs text-gray-400 dark:text-gray-500 text-center mt-6 md:hidden">
          ← Scroll for more →
        </p>
      </div>
    </section>
  );
};

export default CareerTimeline;